System.register(["./dyn-DefaultPropsProvider.js", "./dyn-index.js"], function(exports, module) {
  "use strict";
  var ThemeContext, createTheme, reactExports;
  return {
    setters: [(module2) => {
      ThemeContext = module2.T;
      createTheme = module2.c;
    }, (module2) => {
      reactExports = module2.r;
    }],
    execute: function() {
      exports({
        a: useTheme,
        b: useForkRef,
        s: setRef
      });
      function isObjectEmpty(obj) {
        return Object.keys(obj).length === 0;
      }
      function useTheme$1(defaultTheme = null) {
        const contextTheme = reactExports.useContext(ThemeContext);
        return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
      }
      const systemDefaultTheme = createTheme();
      function useTheme(defaultTheme = systemDefaultTheme) {
        return useTheme$1(defaultTheme);
      }
      const useEnhancedEffect = exports("u", typeof window !== "undefined" ? reactExports.useLayoutEffect : reactExports.useEffect);
      function setRef(ref, value) {
        if (typeof ref === "function") {
          ref(value);
        } else if (ref) {
          ref.current = value;
        }
      }
      function useForkRef(...refs) {
        return reactExports.useMemo(() => {
          if (refs.every((ref) => ref == null)) {
            return null;
          }
          return (instance) => {
            refs.forEach((ref) => {
              setRef(ref, instance);
            });
          };
        }, refs);
      }
    }
  };
});
